module.exports = __webpack_public_path__ + "img/thumb_10.a757541d.jpg";